module.exports = __webpack_public_path__ + "static/bg08-0e4c45f028877727cb8ab742cd1c32ea.webp";